export enum SidebarSize {
  OneThird = 'one-third',
  TwoThirds = 'two-thirds',
  FullScreen = 'full-screen',
}
